var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgError = function SvgError(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.33594,
    y: 4,
    width: 1.33333,
    height: 5.33333,
    rx: 0.666667
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9974 10.5C8.45763 10.5 8.83073 10.8731 8.83073 11.3333C8.83073 11.7936 8.45763 12.1667 7.9974 12.1667C7.53716 12.1667 7.16406 11.7936 7.16406 11.3333C7.16406 10.8731 7.53716 10.5 7.9974 10.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99512 1.33301C11.6769 1.33318 14.6611 4.31821 14.6611 8C14.661 11.6816 11.6768 14.6658 7.99512 14.666C4.31333 14.666 1.3283 11.6817 1.32812 8C1.32812 4.3181 4.31322 1.33301 7.99512 1.33301ZM7.99414 2.66602C5.04888 2.66619 2.66131 5.05376 2.66113 7.99902C2.66113 10.9444 5.04877 13.3328 7.99414 13.333C10.9397 13.333 13.3281 10.9445 13.3281 7.99902C13.3279 5.05365 10.9396 2.66602 7.99414 2.66602Z"
  })));
};
export default SvgError;